import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_next",
  "use": "icon-ic_next-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_next\">\r\n<path d=\"M8.85609 7.39607L5.8388 10.8359C5.64686 11.0547 5.33573 11.0547 5.14389 10.8359C4.95204 10.6172 4.95204 10.2623 5.14389 10.0436L7.81367 7L5.14398 3.95637C4.95213 3.73755 4.95213 3.38284 5.14398 3.16412C5.33583 2.94529 5.64695 2.94529 5.8389 3.16412L8.85619 6.60393C8.95206 6.71334 9 6.85662 9 7C9 7.14338 8.95197 7.28677 8.85609 7.39607Z\" fill=\"#1E1E1E\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol